<!-- ADD CASHIN -->
<p-dialog
  class="filters-modal"
  [header]="paymentLinkOnly ? 'Crear link de pago' : 'Agregar cashin'"
  [modal]="true"
  [(visible)]="showNewCashinType"
  [style]="{ width: '800px' }"
  *ngIf="showNewCashinType"
  (visibleChange)="closeAddModal()"
>
  <div class="pick-title" *ngIf="showCurrency">
    {{
      paymentLinkOnly
        ? 'Selecciona la moneda del link de pago'
        : 'Selecciona la moneda del cashin'
    }}
  </div>
  <div class="form-item" *ngIf="showCurrency">
    <p-dropdown
      placeholder="Elige la moneda"
      [options]="allowedCashinCurrencies"
      optionLabel="id"
      [(ngModel)]="currencyPicker"
      (onChange)="selectCurrency($event)"
      appendTo="body"
    />
  </div>

  <div class="cashin-amount-row" *ngIf="currency">
    <div class="cashin-amount-field">
      <div class="pick-title">
        {{ paymentLinkOnly ? '¿Cuánto quieres cobrar?' : '¿Cuánto quieres recargar?' }}
      </div>
      <div class="form-item">
        <p-inputNumber
          [(ngModel)]="amount"
          [placeholder]="currencyPicker.shortname + ' 0,00'"
          [prefix]="currencyPicker.shortname + ' '"
          class="id-input-filter"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="8"
        />
      </div>
    </div>

    <p-button
      *ngIf="!paymentLinkOnly"
      label="Subida en lotes (.CSV)"
      severity="secondary"
      [outlined]="true"
      (click)="showCsvUpload()"
    />
  </div>

  <div class="pick-title" *ngIf="currency">
    {{
      paymentLinkOnly
        ? 'Selecciona la plataforma para generar el link'
        : 'Selecciona por donde quieres realizar el cashin'
    }}
  </div>
  <div class="pick-type" *ngIf="currency">
    <div
      class="type"
      *ngFor="let provider of providers"
      [class.selected]="getSelected(provider)"
      (click)="setCashinType(provider)"
    >
      <div class="type-icon" *ngIf="provider.id === declarationOption.id">
        <i class="pi pi-wallet"></i>
      </div>
      <div
        class="type-icon"
        *ngIf="
          provider.id === depaIbanOption.id ||
          (isDepaFiatProvider(provider) && !provider.metadata?.image)
        "
      >
        <i class="pi pi-building-columns"></i>
      </div>
      <div
        class="type-icon"
        *ngIf="provider.id === depaCardOption.id && !provider.metadata?.image"
      >
        <i class="pi pi-credit-card"></i>
      </div>
      <div class="type-icon" *ngIf="isCbpayUsdtCashinProvider(provider)">
        <i class="pi pi-credit-card"></i>
      </div>
      <div
        class="type-icon"
        *ngIf="isNotbankProvider(provider) && !provider.metadata?.image"
      >
        <i class="pi pi-wallet"></i>
      </div>
      <!-- <img
        [src]="'img/banks/' + provider.provider.username + '.png'"
        class="provider-img"
      /> -->
      <div
        class="img-container"
        *ngIf="
          provider.id !== declarationOption.id &&
          !isCbpayUsdtCashinProvider(provider)
        "
      >
        <img
          *ngIf="provider.metadata?.image"
          [src]="'img/' + provider.metadata.image + '.png'"
          alt=""
        />
        <img
          *ngIf="provider.metadata?.disclaimer_image"
          [src]="'img/' + provider.metadata.disclaimer_image + '.png'"
          class="disclaimer-img"
        />
      </div>
      <div class="type-channel-name" *ngIf="getProviderChannelName(provider)">
        {{ getProviderChannelName(provider) }}
      </div>
      <div class="type-channel-desc">{{ getProviderCardTitle(provider) }}</div>
      <div class="disclaimer" *ngIf="getProviderCardDisclaimer(provider)">
        {{ getProviderCardDisclaimer(provider) }}
      </div>
    </div>
  </div>
  <div
    class="p-text-secondary"
    *ngIf="paymentLinkOnly && currency && !providers?.length"
  >
    No hay plataformas con link de pago configuradas para esta moneda.
  </div>
  <div class="buttons-container">
    <p-button label="Cancelar" severity="danger" (click)="exitNewCashin()" />
    <p-button
      label="Continuar"
      [disabled]="checkContinueDisabled()"
      severity="secondary"
      (click)="continue()"
    />
  </div>
</p-dialog>

<!-- ADD CASHIN FORM -->
<p-dialog
  [maximizable]="true"
  class="filters-modal add-cashin"
  [header]="
    newCashinType === 'DECLARATION'
      ? 'Declarar cashin'
      : newCashinType === 'CSV'
        ? 'Subir cashins por CSV'
      : isSelectedPayinLinkProvider
        ? 'Crear link de pago'
      : isDepaIbanCashin
        ? 'Depósito por IBAN'
        : isR4ImmediateDebit
          ? 'Débito inmediato'
          : 'Nuevo cashin'
  "
  [modal]="true"
  [(visible)]="showNewCashin"
  [style]="{ width: '1000px' }"
  [contentStyle]="isSelectedPayinLinkProvider ? { overflow: 'hidden' } : {}"
  *ngIf="showNewCashin"
  (visibleChange)="closeAddModal()"
  [closable]="!processing && !r4DebitLoading"
  closeOnEscape="false"
>
  <div class="new-transaction-form" *ngIf="isR4ImmediateDebit">
    <div class="form-title">Débito inmediato R4</div>
    <p class="p-text-secondary">
      El banco del pagador envía el OTP. Guardamos el cashin en VES antes de
      confirmarlo y solo queda finished con respuesta 200 AC00.
    </p>
    <form class="form-container" [formGroup]="r4DebitForm">
      <div class="form-row">
        <div class="filter-column">
          <div class="form-item">
            <label>Monto</label>
            <p-inputNumber
              [(ngModel)]="amount"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="r4DebitStep === 'otp'"
              [prefix]="currencyPicker?.shortname ? currencyPicker.shortname + ' ' : 'VES '"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              class="id-input-filter"
            />
          </div>
          <div class="form-item" *ngIf="auth.hasRole(roles.Admin)">
            <label>Cliente asignado</label>
            <p-dropdown
              placeholder="Elige un cliente"
              formControlName="client_id"
              [options]="userService.users"
              optionLabel="username"
              [filter]="true"
              filterBy="username"
              appendTo="body"
            />
          </div>
          <div class="form-item">
            <label>Wallet</label>
            <input
              type="text"
              value="R4 (0169)"
              pInputText
              class="id-input-filter"
              readonly
            />
          </div>
          <div class="form-item">
            <label>Banco del pagador</label>
            <p-dropdown
              placeholder="Elige el banco"
              formControlName="bank"
              [options]="vzlaBanks"
              optionLabel="name"
              [filter]="true"
              filterBy="name,code"
              appendTo="body"
            />
          </div>
        </div>
        <div class="filter-column">
          <div class="form-item">
            <label>Tipo de documento</label>
            <div class="document-picker">
              <div
                class="docu-type"
                *ngFor="let doc of ['V', 'E', 'J', 'P']"
                [class.selected]="r4DebitForm.controls.id_type.value === doc"
                (click)="setR4DocuType(doc)"
              >
                {{ doc }}
              </div>
            </div>
          </div>
          <div class="form-item">
            <label>Número de documento</label>
            <input
              type="text"
              placeholder="Número de documento"
              formControlName="id_number"
              pInputText
              class="id-input-filter"
            />
          </div>
          <div class="form-item">
            <label>Teléfono</label>
            <input
              type="tel"
              maxlength="11"
              placeholder="04145555555"
              formControlName="telefono"
              pInputText
              class="id-input-filter"
            />
          </div>
          <div class="form-item">
            <label>Nombre</label>
            <input
              type="text"
              maxlength="20"
              placeholder="Hasta 20 caracteres"
              formControlName="nombre"
              pInputText
              class="id-input-filter"
            />
          </div>
        </div>
        <div class="filter-column">
          <div class="form-item">
            <label>Concepto</label>
            <input
              type="text"
              maxlength="30"
              placeholder="Hasta 30 caracteres"
              formControlName="concepto"
              pInputText
              class="id-input-filter"
            />
          </div>
          <div class="form-item" *ngIf="r4DebitStep === 'otp'">
            <label>OTP</label>
            <input
              type="text"
              maxlength="8"
              placeholder="8 dígitos"
              formControlName="otp"
              pInputText
              class="id-input-filter"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        [disabled]="r4DebitLoading"
        (click)="exitNewCashin()"
      />
      <p-button
        *ngIf="r4DebitStep === 'data'"
        label="Solicitar OTP"
        severity="secondary"
        [loading]="r4DebitLoading"
        (click)="requestR4DebitOtp()"
      />
      <p-button
        *ngIf="r4DebitStep === 'otp'"
        label="Confirmar débito"
        severity="secondary"
        [loading]="r4DebitLoading"
        (click)="confirmR4Debit()"
      />
    </div>
  </div>

  <div class="new-transaction-form" *ngIf="newCashinType === 'Kushki'">
    <div class="full-form-container">
      <div class="left-side">
        <div class="form-title">Datos de la tarjeta</div>

        <form class="form-container kushki-form-container">
          <div class="form-row card-form-row">
            <div class="filter-column kushki-filter-column">
              <div class="form-item kushki-form-item">
                <label>Monto</label>
                <div class="amount-value">
                  <span>{{ currencyPicker.shortname }}</span>
                  {{ amount | number: "1.2-8" }}
                </div>
              </div>
              <div class="form-item kushki-form-item">
                <label>Nombre en la tarjeta</label>
                <div id="cardholderName_id"></div>
              </div>
              <div class="form-item kushki-form-item">
                <label>Número de tarjeta</label>
                <div id="cardNumber_id"></div>
              </div>
            </div>
          </div>
          <div class="form-row card-form-row alt">
            <div class="filter-column kushki-filter-column alt">
              <div class="form-item kushki-form-item">
                <label>CVV</label>
                <div id="cvv_id"></div>
              </div>
            </div>
            <div class="filter-column kushki-filter-column">
              <div class="form-item kushki-form-item">
                <label>Fecha de expiración</label>
                <div id="expirationDate_id"></div>
              </div>
            </div>
          </div>
          <div class="kushki-disclaimer">
            Procesamos los pagos de forma segura a través de
            <img src="img/banks/Kushki.png" />
          </div>
        </form>
      </div>
      <div class="right-side">
        <div class="form-title">Datos de contacto y facturación</div>

        <form class="form-container" [formGroup]="newCashinForm">
          <div class="form-row">
            <div class="filter-column">
              <div class="form-item">
                <label>Nombre</label>
                <input
                  formControlName="firstName"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Apellido</label>
                <input
                  formControlName="lastName"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Tipo de documento</label>
                <input
                  formControlName="documentType"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Número de documento</label>
                <input
                  formControlName="documentNumber"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Correo electrónico</label>
                <input
                  formControlName="email"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Teléfono</label>
                <p-inputNumber
                  [useGrouping]="false"
                  formControlName="phone"
                  prefix="+"
                  placeholder="+"
                  class="id-input-filter"
                />
              </div>
            </div>
            <div class="filter-column">
              <div class="form-item">
                <label>Dirección</label>
                <input
                  formControlName="address"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Ciudad</label>
                <input
                  formControlName="city"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Región</label>
                <input
                  formControlName="region"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>País</label>
                <input
                  formControlName="country"
                  pInputText
                  class="id-input-filter"
                />
              </div>
              <div class="form-item">
                <label>Código Postal</label>
                <input
                  formControlName="zipcode"
                  pInputText
                  class="id-input-filter"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="buttons-container">
      <p-button
        *ngIf="!processing"
        label="Cancelar"
        severity="danger"
        (click)="exitNewCashin()"
      />
      <p-button
        [label]="processing ? 'Procesando cashin' : 'Procesar cashin'"
        [disabled]="processing"
        [loading]="processing"
        severity="secondary"
        (click)="createToken()"
      />
    </div>
  </div>

  <div class="new-transaction-form" *ngIf="newCashinType === 'CSV'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv con los cashins a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashins/' + currency + '.csv'"
        [download]="currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>

    <div class="form-container">
      <div class="form-row">
        <div class="filter-column">
          <div class="form-item">
            <label for="cashin_csv_file">Archivo CSV</label>
            <input
              id="cashin_csv_file"
              class="csv-file-input"
              type="file"
              accept=".csv"
              (change)="onFileSelected($event)"
            />
            <label class="csv-upload-box" for="cashin_csv_file">
              <span class="csv-upload-icon">
                <i class="pi pi-upload"></i>
              </span>
              <span class="csv-upload-copy">
                <span class="csv-upload-title">
                  {{ selectedFile?.name || "Selecciona tu archivo CSV" }}
                </span>
                <span class="csv-upload-subtitle">
                  {{
                    selectedFile
                      ? "Archivo listo para subir"
                      : "Solo archivos .csv"
                  }}
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons-container">
      <p-button
        *ngIf="!uploadingCSV"
        label="Volver al formulario"
        severity="secondary"
        [outlined]="true"
        (click)="showCashinTypeSelector()"
      />
      <p-button
        [label]="uploadingCSV ? 'Subiendo CSV' : 'Subir CSV'"
        [disabled]="!selectedFile || uploadingCSV"
        [loading]="uploadingCSV"
        severity="secondary"
        (click)="uploadCashinCSV()"
      />
    </div>
  </div>

  <div class="new-transaction-form" *ngIf="newCashinType === 'DECLARATION'">
    <div class="form-title">Ingresa los datos del cashin declarado</div>
    <p class="p-text-secondary" *ngIf="isCryptoDeclaredCashin">
      Elige la red para ver la wallet de destino, envía el depósito y declara el
      hash de la transacción.
    </p>

    <form class="form-container" [formGroup]="declarationCashinForm">
      <div class="form-row">
        <div class="filter-column">
          <div class="form-item">
            <label for="declaration_amount">Monto</label>
            <p-inputNumber
              inputId="declaration_amount"
              [ngModel]="amount"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="true"
              [prefix]="
                currencyPicker?.shortname ? currencyPicker.shortname + ' ' : ''
              "
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="8"
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="auth.hasRole(roles.Admin)">
            <label for="client_id">Cliente asignado</label>
            <p-dropdown
              placeholder="Elige un cliente"
              formControlName="client_id"
              [options]="userService.users"
              optionLabel="username"
              [filter]="true"
              filterBy="username"
              appendTo="body"
              (onChange)="onDeclaredCashinClientChanged()"
            />
          </div>

          <div class="form-item">
            <label for="wallet">{{ declaredCashinWalletLabel }}</label>
            <p-dropdown
              id="wallet"
              [placeholder]="declaredCashinWalletPlaceholder"
              formControlName="wallet"
              [options]="getDeclaredCashinWallets(currency)"
              optionLabel="shortname"
              [filter]="true"
              filterBy="shortname,name,id"
              appendTo="body"
            />
          </div>
        </div>
        <div class="filter-column">
          <div class="form-item">
            <label for="reference"
              >{{ declaredCashinReferenceLabel
              }}<span
                class="required"
                *ngIf="currency === 'VES' || isCryptoDeclaredCashin"
                >*</span
              ></label
            >
            <input
              id="reference"
              [placeholder]="declaredCashinReferencePlaceholder"
              formControlName="reference"
              pInputText
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="auth.hasRole(roles.Admin)">
            <label for="commission">Monto de comisión (opcional)</label>
            <input
              id="commission"
              type="number"
              min="0"
              placeholder="0"
              formControlName="commission"
              pInputText
              class="id-input-filter"
            />
            <small class="p-text-secondary" *ngIf="currency === 'VES'">
              Se busca por monto total; el cashin se registra con monto total −
              comisión.
            </small>
            <small class="p-text-secondary" *ngIf="currency !== 'VES'">
              El cashin se registra con monto total − comisión.
            </small>
            <div class="ves-fee-preview" *ngIf="declarationNetAmount !== null">
              <strong>Monto a acreditar:</strong>
              {{ declarationNetAmount | number: "1.2-2" }} (total − comisión)
            </div>
          </div>
        </div>
      </div>

      <div class="form-item crypto-deposit-panel" *ngIf="isCryptoDeclaredCashin">
        <small class="p-text-secondary" *ngIf="declaredCryptoAddressLoading">
          Buscando wallet de destino...
        </small>
        <ng-container *ngIf="declaredCashinDepositAddress as address">
          <label>Wallet de destino</label>
          <div class="link-box">
            <input
              type="text"
              pInputText
              [value]="address"
              readonly
              class="link-input w-full"
            />
            <i
              class="pi pi-copy copy-icon"
              (click)="utilsService.copyToClipboard(address)"
              pTooltip="Copiar wallet"
            ></i>
          </div>
          <small class="p-text-secondary">
            Envía {{ currency }} a esta address
            <ng-container *ngIf="declaredCashinDepositNetwork">
              en {{ declaredCashinDepositNetwork }}
            </ng-container>
            y luego ingresa el hash de la transacción.
          </small>
        </ng-container>
        <small
          class="p-text-secondary"
          *ngIf="!declaredCashinSelectedWallet && !declaredCryptoAddressLoading"
        >
          Elige la red para ver la wallet donde debes enviar.
        </small>
        <small
          class="p-text-secondary"
          *ngIf="
            declaredCashinSelectedWallet &&
            !declaredCashinDepositAddress &&
            !declaredCryptoAddressLoading
          "
        >
          Esta red no tiene una address de depósito configurada. Revisa la
          metadata del provider TRC20 o provisiona la wallet crypto del cliente.
        </small>
      </div>

      <div class="form-separator" *ngIf="hasDeclaredCashinExtraFields"></div>

      <app-eur-cashin-form
        *ngIf="currency === 'EUR'"
        [ctx]="cashinContext"
      />
      <app-cop-cashin-form
        *ngIf="currency === 'COP'"
        [ctx]="cashinContext"
      />
      <app-aed-cashin-form
        *ngIf="currency === 'AED'"
        [ctx]="cashinContext"
      />
      <app-mxn-cashin-form
        *ngIf="currency === 'MXN'"
        [ctx]="cashinContext"
      />
      <app-usd-cashin-form
        *ngIf="currency === 'USD'"
        [ctx]="cashinContext"
      />
      <app-btc-cashin-form
        *ngIf="currency === 'BTC'"
        [ctx]="cashinContext"
      />
      <app-eth-cashin-form
        *ngIf="currency === 'ETH'"
        [ctx]="cashinContext"
      />
      <app-usdt-cashin-form
        *ngIf="currency === 'USDT'"
        [ctx]="cashinContext"
      />
    </form>

    <div class="buttons-container">
      <p-button
        *ngIf="!processing"
        label="Cancelar"
        severity="danger"
        (click)="exitNewCashin()"
      />
      <p-button
        [label]="processing ? 'Guardando cashin' : 'Guardar cashin'"
        [disabled]="declarationCashinForm.invalid || processing"
        [loading]="processing"
        severity="secondary"
        (click)="saveDeclaredCashin()"
      />
    </div>
  </div>

  <div class="new-transaction-form" *ngIf="isSelectedPayinLinkProvider">
    <div
      class="payin-link-layout"
      [class.payin-link-layout-compact]="isSelectedCbpayProvider"
    >
      <div class="payin-link-scroll">
        <div class="form-title">Ingresa los datos para generar el link de pago</div>
        <div
          class="form-subtitle"
          *ngIf="getProviderChannelName(selectedProvider)"
        >
          Canal: {{ getProviderChannelName(selectedProvider) }}
        </div>
        <p class="p-text-secondary mb-3" *ngIf="notbankCashinHint">
          {{ notbankCashinHint }}
        </p>

        <form class="form-container" [formGroup]="payinLinkCashinForm">
      <div class="form-row">
        <div class="filter-column">
          <div class="form-item">
            <label for="payin_amount">
              {{
                isSelectedDepaCard || isSelectedCbpayProvider
                  ? "Monto a acreditar"
                  : "Monto"
              }}
            </label>
            <p-inputNumber
              inputId="payin_amount"
              [ngModel]="amount"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="true"
              [prefix]="
                currencyPicker?.shortname ? currencyPicker.shortname + ' ' : ''
              "
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="8"
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="auth.hasRole(roles.Admin)">
            <label for="payin_client_id">Cliente asignado</label>
            <p-dropdown
              id="payin_client_id"
              placeholder="Elige un cliente"
              formControlName="client_id"
              [options]="userService.users"
              optionLabel="username"
              [filter]="true"
              filterBy="username"
              appendTo="body"
              (onChange)="onPayinLinkClientChanged()"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoEurProvider || isSelectedDepaProvider">
            <label for="payin_wallet"
              >Wallet destino <span class="required">*</span></label
            >
            <p-dropdown
              id="payin_wallet"
              placeholder="Elige un wallet"
              formControlName="wallet"
              [options]="getPayinDestinyWallets(currency)"
              optionLabel="shortname"
              [filter]="true"
              filterBy="shortname"
              appendTo="body"
            />
          </div>

          <div
            class="form-item"
            *ngIf="!isSelectedMinteoCoProvider && !isSelectedCbpayProvider"
          >
            <label for="payer_name"
              >Nombre del pagador
              <span
                class="required"
                *ngIf="isSelectedDepaChannel || isSelectedBitsoMxProvider || isSelectedBitsoCoProvider"
                >*</span
              ></label
            >
            <input
              id="payer_name"
              placeholder="Nombre completo"
              formControlName="payer_name"
              pInputText
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedCbpayProvider">
            <label for="payer_first_name">Nombre</label>
            <input
              id="payer_first_name"
              placeholder="Nombre"
              formControlName="payer_first_name"
              maxlength="120"
              pInputText
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoCoProvider">
            <label for="third_party_full_name"
              >Nombre completo del pagador
              <span class="required">*</span></label
            >
            <input
              id="third_party_full_name"
              pInputText
              formControlName="third_party_full_name"
              placeholder="Nombre y apellidos"
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoCoProvider || isSelectedBitsoCoProvider">
            <label for="third_party_legal_identifier_type"
              >Tipo de documento
              <span class="required" *ngIf="isSelectedBitsoCoProvider">*</span></label
            >
            <p-dropdown
              id="third_party_legal_identifier_type"
              formControlName="third_party_legal_identifier_type"
              [options]="LEGAL_IDENTIFIER_TYPES"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            />
          </div>
        </div>

        <div class="filter-column">
          <div class="form-item" *ngIf="isSelectedCbpayProvider">
            <label for="payer_last_name">Apellido</label>
            <input
              id="payer_last_name"
              placeholder="Apellido"
              formControlName="payer_last_name"
              maxlength="120"
              pInputText
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="!isSelectedMinteoCoProvider">
            <label for="payer_email"
              >Email del pagador
              <span class="required" *ngIf="isSelectedDepaChannel">*</span></label
            >
            <input
              id="payer_email"
              type="email"
              placeholder="email@ejemplo.com"
              formControlName="payer_email"
              pInputText
              class="id-input-filter"
            />
          </div>

          <div
            class="form-item"
            *ngIf="!isSelectedMinteoCoProvider && !isSelectedCbpayProvider"
          >
            <label for="payer_phone"
              >Teléfono del pagador
              <span class="required" *ngIf="isSelectedBitsoCoProvider">*</span></label
            >
            <input
              id="payer_phone"
              [placeholder]="payerPhonePlaceholder"
              formControlName="payer_phone"
              pInputText
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoCoProvider">
            <label for="third_party_email"
              >Email del pagador <span class="required">*</span></label
            >
            <input
              id="third_party_email"
              type="email"
              pInputText
              formControlName="third_party_email"
              placeholder="email@ejemplo.com"
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoCoProvider">
            <label for="third_party_phone_number"
              >Teléfono del pagador <span class="required">*</span></label
            >
            <input
              id="third_party_phone_number"
              type="tel"
              pInputText
              formControlName="third_party_phone_number"
              placeholder="+57 300 123 4567"
              class="id-input-filter"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoCoProvider || isSelectedBitsoCoProvider">
            <label for="pse_bank"
              >Banco de origen
              <span
                class="required"
                *ngIf="isSelectedMinteoCoProvider || isSelectedBitsoCoProvider"
                >*</span
              ></label
            >
            <p-dropdown
              id="pse_bank"
              formControlName="pse_bank"
              [options]="PSE_BANKS_CO"
              optionLabel="label"
              optionValue="code"
              placeholder="Selecciona el banco"
              [filter]="true"
              filterBy="label"
              appendTo="body"
            />
          </div>

          <div class="form-item" *ngIf="isSelectedMinteoCoProvider || isSelectedBitsoCoProvider">
            <label for="third_party_legal_identifier"
              >Número de documento <span class="required">*</span></label
            >
            <input
              id="third_party_legal_identifier"
              pInputText
              formControlName="third_party_legal_identifier"
              placeholder="Cédula o documento"
              class="id-input-filter"
            />
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="isSelectedCbpayProvider">
        <div class="filter-column">
          <div class="form-item">
            <label for="cbpay_payer_address">Dirección</label>
            <input
              id="cbpay_payer_address"
              formControlName="payer_address"
              maxlength="120"
              pInputText
              class="id-input-filter"
              placeholder="Dirección de facturación"
            />
          </div>
        </div>

        <div class="filter-column">
          <div class="form-item">
            <label for="cbpay_payer_city">Ciudad</label>
            <input
              id="cbpay_payer_city"
              formControlName="payer_city"
              maxlength="120"
              pInputText
              class="id-input-filter"
              placeholder="Ciudad"
            />
          </div>

          <div class="form-item">
            <label for="cbpay_payer_country">País</label>
            <input
              id="cbpay_payer_country"
              formControlName="payer_country"
              maxlength="120"
              pInputText
              class="id-input-filter"
              placeholder="País"
            />
          </div>
        </div>
      </div>

      <div class="card-fee-summary" *ngIf="isSelectedCbpayProvider">
        <small class="p-text-secondary" *ngIf="cbpayFeeLoading">
          Calculando comisión...
        </small>
        <small class="card-fee-error" *ngIf="cbpayFeeError">
          {{ cbpayFeeError }}
        </small>
        <ng-container *ngIf="cbpayFeePreview as feePreview">
          <div class="card-fee-row">
            <span>Monto a acreditar</span>
            <strong>
              {{ feePreview.currency }} {{ feePreview.net | number: "1.2-6" }}
            </strong>
          </div>
          <div class="card-fee-row">
            <span>
              Costo del servicio
              <small class="card-fee-formula">
                <ng-container *ngIf="feePreview.percentage > 0">
                  {{ feePreview.percentage | number: "1.0-4" }} %
                </ng-container>
                <ng-container *ngIf="feePreview.flat > 0">
                  <ng-container *ngIf="feePreview.percentage > 0"> + </ng-container>
                  {{ feePreview.flat | number: "1.2-6" }} {{ feePreview.currency }}
                </ng-container>
                <ng-container
                  *ngIf="feePreview.percentage <= 0 && feePreview.flat <= 0"
                >
                  Sin costo adicional
                </ng-container>
              </small>
            </span>
            <strong>
              {{ feePreview.currency }} {{ feePreview.fee | number: "1.2-6" }}
            </strong>
          </div>
          <div class="card-fee-row card-fee-total">
            <span>Subtotal del enlace</span>
            <strong>
              {{ feePreview.currency }} {{ feePreview.gross | number: "1.2-6" }}
            </strong>
          </div>
          <small class="card-fee-note">
            El pago se realizará en USD. Al crear el enlace verás el cobro
            aproximado en tarjeta; el monto definitivo se confirmará antes de
            pagar y puede variar ligeramente por la conversión.
          </small>
        </ng-container>
      </div>

      <div class="form-row" *ngIf="isSelectedDepaCard">
        <div class="filter-column">
          <div class="form-item">
            <label for="payer_address"
              >Dirección de facturación <span class="required">*</span></label
            >
            <input
              id="payer_address"
              formControlName="payer_address"
              pInputText
              class="id-input-filter"
              placeholder="Calle, número y complemento"
            />
          </div>
          <div class="form-item">
            <label for="payer_city"
              >Ciudad <span class="required">*</span></label
            >
            <input
              id="payer_city"
              formControlName="payer_city"
              pInputText
              class="id-input-filter"
            />
          </div>
          <div class="form-item">
            <label for="payer_state">Estado / provincia</label>
            <input
              id="payer_state"
              formControlName="payer_state"
              pInputText
              class="id-input-filter"
            />
          </div>
        </div>
        <div class="filter-column">
          <div class="form-item">
            <label for="payer_postal_code"
              >Código postal <span class="required">*</span></label
            >
            <input
              id="payer_postal_code"
              formControlName="payer_postal_code"
              pInputText
              class="id-input-filter"
            />
          </div>
            <div class="form-item">
              <label for="payer_country_code"
              >País <span class="required">*</span></label
            >
            <p-dropdown
              id="payer_country_code"
              formControlName="payer_country_code"
              [options]="countryOptions"
              optionLabel="name"
              optionValue="code"
              [filter]="true"
              filterBy="name,code"
              placeholder="Selecciona el país"
              appendTo="body"
              />
            </div>
            <div class="card-fee-summary" *ngIf="isSelectedDepaCard">
              <small class="p-text-secondary" *ngIf="depaCardFeeLoading">
                Calculando comisión...
              </small>
              <small class="card-fee-error" *ngIf="depaCardFeeError">
                {{ depaCardFeeError }}
              </small>
              <ng-container *ngIf="depaCardFeePreview as feePreview">
                <div class="card-fee-row">
                  <span>Monto a acreditar</span>
                  <strong>{{ feePreview.currency }} {{ feePreview.net | number: "1.2-8" }}</strong>
                </div>
                <div class="card-fee-row">
                  <span>
                    Comisión estimada
                    <small class="card-fee-formula">
                      <ng-container *ngIf="feePreview.percentage > 0">
                        {{ feePreview.percentage | number: "1.0-4" }} %
                      </ng-container>
                      <ng-container *ngIf="feePreview.flat > 0">
                        <ng-container *ngIf="feePreview.percentage > 0"> + </ng-container>
                        {{ feePreview.currency }}
                        {{ feePreview.flat | number: "1.2-8" }}
                      </ng-container>
                      <ng-container
                        *ngIf="feePreview.percentage <= 0 && feePreview.flat <= 0"
                      >
                        Sin costo adicional
                      </ng-container>
                    </small>
                  </span>
                  <strong>{{ feePreview.currency }} {{ feePreview.fee | number: "1.2-8" }}</strong>
                </div>
                <div class="card-fee-row card-fee-total">
                  <span>Total aproximado a cobrar</span>
                  <strong>{{ feePreview.currency }} {{ feePreview.gross | number: "1.2-8" }}</strong>
                </div>
                <small class="card-fee-note">
                  El entorno seguro confirmará el cobro final. Si el pago se
                  completa, se acreditarán {{ feePreview.currency }}
                  {{ feePreview.net | number: "1.2-8" }}.
                </small>
              </ng-container>
            </div>
          </div>
      </div>

      <!-- CLP / PEN payment method (URL or QR). Same checkout URL shape for the 3 CLP rails. -->
      <div class="form-row" *ngIf="showNotbankPayinMethod">
        <div class="filter-column">
          <div class="form-item">
            <label for="payment_method"
              >Método de cobro <span class="required">*</span></label
            >
            <p-dropdown
              id="payment_method"
              formControlName="payment_method"
              [options]="notbankPayinMethodOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecciona el método"
              appendTo="body"
              styleClass="w-full"
            />
          </div>
        </div>
      </div>

      <!-- Notbank bank destination: COP / BRL / ARS (pm=bank_transfer) -->
      <div class="form-row" *ngIf="notbankCashinNeedsBank">
        <div class="filter-column">
          <div class="form-item">
            <label for="notbank_bank"
              >{{ notbankBankLabel }} <span class="required">*</span></label
            >
            <p-dropdown
              id="notbank_bank"
              formControlName="notbank_bank"
              [options]="notbankBanks"
              optionLabel="label"
              [filter]="true"
              filterBy="label,name"
              [loading]="loadingNotbankBanks"
              placeholder="Selecciona el banco"
              appendTo="body"
              styleClass="w-full"
            />
          </div>

          <div class="form-item">
            <label for="notbank_kind"
              >{{ notbankKindLabel }} <span class="required">*</span></label
            >
            <p-dropdown
              id="notbank_kind"
              formControlName="notbank_kind"
              [options]="notbankCashinKindOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Elige PIX o tipo de cuenta"
              appendTo="body"
              styleClass="w-full"
            />
            <small class="p-text-secondary" *ngIf="currency === 'BRL'">
              PIX: solo tipo de clave + valor. Cuenta bancaria: también agencia y
              DV.
            </small>
          </div>
        </div>

        <div class="filter-column">
          <div class="form-item" *ngIf="notbankCashinIsPix">
            <label for="notbank_pix_type"
              >Tipo de clave PIX <span class="required">*</span></label
            >
            <p-dropdown
              id="notbank_pix_type"
              formControlName="notbank_pix_type"
              [options]="notbankPixTypeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Email, CPF, Phone o EVP"
              appendTo="body"
              styleClass="w-full"
            />
          </div>

          <div class="form-item">
            <label for="notbank_number"
              >{{ notbankNumberLabel }} <span class="required">*</span></label
            >
            <input
              id="notbank_number"
              pInputText
              formControlName="notbank_number"
              class="id-input-filter"
              [placeholder]="notbankNumberPlaceholder"
            />
          </div>

          <ng-container *ngIf="currency === 'BRL' && !notbankCashinIsPix">
            <div class="form-item">
              <label for="notbank_agency"
                >Agencia bancaria <span class="required">*</span></label
              >
              <input
                id="notbank_agency"
                pInputText
                formControlName="notbank_agency"
                class="id-input-filter"
                placeholder="Ej. 0001"
              />
            </div>
            <div class="form-item">
              <label for="notbank_dv"
                >Dígito verificador (DV) <span class="required">*</span></label
              >
              <input
                id="notbank_dv"
                pInputText
                formControlName="notbank_dv"
                class="id-input-filter"
                placeholder="Ej. 0"
              />
            </div>
          </ng-container>
        </div>
      </div>
        </form>
      </div>

      <div class="payin-link-footer">
        <div class="buttons-container payin-link-buttons">
          <p-button
            *ngIf="!processing"
            label="Cancelar"
            severity="danger"
            (click)="exitNewCashin()"
          />
          <p-button
            [label]="processing ? 'Creando link' : 'Crear link de pago'"
            [disabled]="
              processing ||
              (isSelectedDepaCard &&
                (depaCardFeeLoading ||
                  !!depaCardFeeError ||
                  !depaCardFeePreview)) ||
              (isSelectedCbpayProvider &&
                (cbpayFeeLoading || !!cbpayFeeError || !cbpayFeePreview))
            "
            [loading]="processing"
            severity="secondary"
            (click)="createPayinLinkCashin()"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="new-transaction-form" *ngIf="isDepaIbanCashin">
    <div class="form-title">Depósito por transferencia a IBAN</div>
    <ol class="p-text-secondary mb-3 depa-iban-steps">
      <li>Consulta el IBAN del cliente (abajo). No se crea un cashin todavía.</li>
      <li>Transfiere desde el banco a ese IBAN (el monto lo define la transferencia).</li>
      <li>
        Al confirmarse el pago entrante, el cashin se crea y se asigna
        automáticamente a la wallet del cliente.
      </li>
      <li>Revísalo después en el listado de cashins.</li>
    </ol>
    <p class="p-text-secondary mb-3">
      <strong>No crees un cashin manual</strong> para este método: no hay matching
      por referencia; la asignación es por IBAN/cuenta del cliente.
    </p>

    <form class="form-container mb-3" [formGroup]="payinLinkCashinForm" *ngIf="auth.hasRole(roles.Admin)">
      <div class="form-item">
        <label for="depa_iban_client_id">Cliente</label>
        <p-dropdown
          id="depa_iban_client_id"
          placeholder="Elige un cliente"
          formControlName="client_id"
          [options]="userService.users"
          optionLabel="username"
          [filter]="true"
          filterBy="username"
          appendTo="body"
          (onChange)="loadDepaDepositInstructions()"
        />
      </div>
    </form>

    <div *ngIf="depaDepositLoading" class="p-text-secondary">
      Cargando instrucciones...
    </div>

    <div
      *ngIf="!depaDepositLoading && depaDepositUnavailable"
      class="depa-iban-missing mb-3"
    >
      <p class="p-text-secondary mb-3">
        Este cliente no tiene cuenta Depa en {{ currency }} todavía. Si el alta
        automática falló, puedes solicitarla ahora.
      </p>
      <p-button
        label="Solicitar cuenta Depa"
        icon="pi pi-plus"
        severity="secondary"
        (click)="openDepaAccountRequest()"
      />
    </div>

    <div *ngIf="depaDepositInstructions as info" class="depa-iban-panel">
      <div class="form-item" *ngIf="info.currency">
        <label>Moneda</label>
        <input type="text" pInputText [value]="info.currency" readonly class="w-full" />
      </div>
      <div class="form-item" *ngIf="info.iban">
        <label>IBAN</label>
        <div class="link-box payin-created-link-box">
          <input
            type="text"
            pInputText
            [value]="info.iban"
            readonly
            class="link-input w-full"
          />
          <i
            class="pi pi-copy copy-icon"
            (click)="utilsService.copyToClipboard(info.iban)"
            pTooltip="Copiar IBAN"
          ></i>
        </div>
      </div>
      <p class="p-text-secondary" *ngIf="info.instructions">
        {{ info.instructions }}
      </p>
    </div>

    <div class="buttons-container">
      <p-button label="Cerrar" severity="secondary" (click)="exitNewCashin()" />
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Pago seguro con tarjeta"
  [(visible)]="showDepaCardCheckout"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '760px' }"
  *ngIf="showDepaCardCheckout"
  (onHide)="closeDepaCardCheckout()"
>
  <p class="p-text-secondary mb-3" *ngIf="!depaCardCheckoutCompleted">
    Los datos se ingresan directamente en el entorno seguro de pagos.
    TransferSwap no recibe ni almacena el número de tarjeta o el CVC.
  </p>
  <div
    class="card-fee-summary mb-3"
    *ngIf="!depaCardCheckoutCompleted && depaCardCheckoutFee as feePreview"
  >
    <div class="card-fee-row">
      <span>Monto a acreditar</span>
      <strong>{{ feePreview.currency }} {{ feePreview.net | number: "1.2-8" }}</strong>
    </div>
    <div class="card-fee-row">
      <span>Comisión estimada</span>
      <strong>{{ feePreview.currency }} {{ feePreview.fee | number: "1.2-8" }}</strong>
    </div>
    <div class="card-fee-row card-fee-total">
      <span>Total aproximado a cobrar</span>
      <strong>{{ feePreview.currency }} {{ feePreview.gross | number: "1.2-8" }}</strong>
    </div>
    <small class="card-fee-note">
      El entorno seguro confirmará el cobro final. Si el pago se completa, se
      acreditarán {{ feePreview.currency }}
      {{ feePreview.net | number: "1.2-8" }}.
    </small>
  </div>
  <div class="depa-card-widget-frame" *ngIf="depaCardWidgetUrl">
    <iframe
      title="Checkout seguro de tarjeta"
      [src]="depaCardWidgetUrl"
      allow="camera; microphone; geolocation; payment"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
  </div>
  <div class="depa-card-success" *ngIf="depaCardCheckoutCompleted">
    <span class="depa-card-success-icon" aria-hidden="true">
      <i class="pi pi-check"></i>
    </span>
    <h3>Pago recibido</h3>
    <p>{{ depaCardCheckoutStatus }}</p>
  </div>
  <p
    class="depa-card-widget-status"
    *ngIf="depaCardCheckoutStatus && !depaCardCheckoutCompleted"
  >
    {{ depaCardCheckoutStatus }}
  </p>
  <ng-template pTemplate="footer">
    <p-button
      label="Cerrar"
      severity="secondary"
      (click)="closeDepaCardCheckout()"
    />
  </ng-template>
</p-dialog>

<p-dialog
  header="{{ payinCreatedModalHeader }}"
  [(visible)]="showPayinLinkCreatedModal"
  [modal]="true"
  [style]="{ width: '560px' }"
  *ngIf="showPayinLinkCreatedModal"
  (onHide)="closePayinLinkCreatedModal()"
>
  <ng-container *ngIf="payinCreatedQrValue; else payinCreatedUrlBlock">
    <p class="p-text-secondary mb-3">
      Muestra este QR al pagador para completar el depósito. También puedes
      copiar el payload.
    </p>
    <div
      *ngIf="payinCreatedQrDataUrl"
      style="display: flex; justify-content: center; padding: 12px"
    >
      <img
        [src]="payinCreatedQrDataUrl"
        alt="QR de pago"
        width="240"
        height="240"
      />
    </div>
    <div class="link-box payin-created-link-box">
      <input
        type="text"
        pInputText
        [value]="payinCreatedQrValue"
        readonly
        class="link-input w-full"
      />
      <i
        class="pi pi-copy copy-icon"
        (click)="utilsService.copyToClipboard(payinCreatedQrValue)"
        pTooltip="Copiar payload QR"
      ></i>
    </div>
  </ng-container>
  <ng-template #payinCreatedUrlBlock>
    <div class="payin-created-card" *ngIf="payinCreatedAppLink">
      <div class="payin-created-hero">
        <span class="payin-created-success-icon" aria-hidden="true">
          <i class="pi pi-check"></i>
        </span>
        <div>
          <h3>¡Link listo para compartir!</h3>
          <p>El enlace está preparado para completar el pago de forma segura.</p>
        </div>
      </div>

      <div class="payin-created-charge" *ngIf="payinCreatedCardCharge as charge">
        <div class="payin-created-charge-main">
          <span>Cobro aproximado en tarjeta</span>
          <strong>
            {{ charge.currency }} {{ charge.amount | number: "1.2-2" }}
          </strong>
        </div>
        <div class="payin-created-breakdown" *ngIf="payinCreatedFee as fee">
          <span>
            Acreditación
            <strong>{{ fee.currency }} {{ fee.net | number: "1.2-6" }}</strong>
          </span>
          <span>
            Objetivo procesado
            <strong>{{ fee.currency }} {{ fee.gross | number: "1.2-6" }}</strong>
          </span>
        </div>
        <small>
          Esta es una referencia en USD para acreditar el objetivo en USDT. El
          importe definitivo será el que muestre el checkout al momento de
          pagar y puede variar por la conversión y los costos del medio de
          pago.
        </small>
      </div>

      <div class="payin-created-secure-link">
        <span class="payin-created-lock" aria-hidden="true">
          <i class="pi pi-lock"></i>
        </span>
        <div class="payin-created-link-label">
          <small>Enlace protegido</small>
          <strong>{{ maskedPayinCreatedAppLink }}</strong>
        </div>
        <button
          type="button"
          class="payin-created-copy-icon"
          (click)="copyPayinCreatedLink()"
          pTooltip="Copiar enlace"
          aria-label="Copiar enlace de pago"
        >
          <i class="pi pi-copy"></i>
        </button>
      </div>
      <small class="payin-created-privacy">
        La dirección real permanece oculta. Al copiar se comparte el enlace
        completo y seguro.
      </small>

      <div class="payin-created-actions">
        <p-button
          label="Abrir checkout"
          icon="pi pi-external-link"
          severity="secondary"
          (click)="openPayinCreatedLink()"
        />
        <p-button
          label="Copiar enlace"
          icon="pi pi-copy"
          (click)="copyPayinCreatedLink()"
        />
      </div>
    </div>
    <app-payin-deposit-details
      *ngIf="
        payinCreatedDepositInstructions ||
        payinCreatedManualValidation ||
        payinCreatedProviderError
      "
      [instructions]="payinCreatedDepositInstructions"
      [isManualValidation]="payinCreatedManualValidation"
      [providerError]="payinCreatedProviderError"
      [message]="payinCreatedMessage"
      [transactionId]="payinCreatedTransactionId"
    />
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button
      label="Cerrar"
      severity="secondary"
      (click)="closePayinLinkCreatedModal()"
    />
  </ng-template>
</p-dialog>

<app-notbank-provision-dialog
  [(visible)]="showNotbankProvision"
  [clientId]="notbankProvisionClientId"
  [currency]="currency"
  [missingFields]="notbankProvisionMissing"
  [partialRegister]="notbankProvisionPartial"
  [bankAccount]="notbankProvisionBank"
  [errorMessage]="notbankProvisionError"
  (provisioned)="onNotbankProvisioned($event)"
  (cancelled)="onNotbankProvisionCancelled()"
/>

<app-depa-personal-account-dialog
  [(visible)]="showDepaAccountRequest"
  [userId]="depaRequestClientId()"
  [username]="depaRequestUsername()"
  [currency]="currency"
  (provisioned)="onDepaAccountProvisioned()"
/>
